import type { LucideIcon } from 'lucide-react'
import {
  BookOpen,
  Crown,
  Flame,
  Library,
  RotateCcw,
  Sparkles,
  Star,
  Target,
  Trophy,
} from 'lucide-react'

const iconMap: Record<string, LucideIcon> = {
  sparkles: Sparkles,
  flame: Flame,
  library: Library,
  'book-open': BookOpen,
  trophy: Trophy,
  crown: Crown,
  'rotate-ccw': RotateCcw,
  star: Star,
  target: Target,
}

export function getAchievementIcon(icon: string): LucideIcon {
  return iconMap[icon] ?? Trophy
}
